import { lazy } from 'react';

import //ManageApps,
//AdvancedExcludeSettingsPage,
//LocalExcludeSettingsPage,
//GeneralSettingsPage,
//Dashboard,
//CampaignsManager,
//Reports,
//LocalMinimumServingPage,
//LocalAppInstallPostbackPage,
//LocalPlacementsPage,
//AdvancedMinimumServingPage,
//AdvancedAppInstallPostbackPage
//EditCampaignPage
//NewCampaign_emptyPage
'views';

// const ManageApps = lazy(() =>
//   import('views').then((module) => {
//     return { default: module.ManageApps };
//   }),
// );

const ManageApps = lazy(() => import('../views/manageAppsPage/ManageApps'));
const AdvancedExcludeSettingsPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.AdvancedExcludeSettingsPage };
  }),
);
const LocalExcludeSettingsPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.LocalExcludeSettingsPage };
  }),
);
const GeneralSettingsPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.GeneralSettingsPage };
  }),
);
const AccountSettingsPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.AccountSettingsPage };
  }),
);
const Dashboard = lazy(() =>
  import('views').then((module) => {
    return { default: module.Dashboard };
  }),
);

const EditCampaignPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.EditCampaignPage };
  }),
);
const NewCampaign_emptyPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.NewCampaign_emptyPage };
  }),
);

const DirectCampaignPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.DirectCampaignPage };
  }),
);

const DuplicateCampaignPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.DuplicateCampaignPage };
  }),
);

const CampaignsManager_v2 = lazy(() =>
  import('views').then((module) => {
    return { default: module.CampaignManager_v2 };
  }),
);

const CampaignsManager = lazy(() =>
  import('views').then((module) => {
    return { default: module.CampaignsManager };
  }),
);
const PublisherReports = lazy(() =>
  import('views').then((module) => {
    return { default: module.PublisherReports };
  }),
);
const CampaignReports = lazy(() =>
  import('views').then((module) => {
    return { default: module.CampaignReports };
  }),
);
const LocalMinimumServingPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.LocalMinimumServingPage };
  }),
);
const LocalAppInstallPostbackPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.LocalAppInstallPostbackPage };
  }),
);
const LocalPlacementsPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.LocalPlacementsPage };
  }),
);
const AdvancedMinimumServingPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.AdvancedMinimumServingPage };
  }),
);
const AdvancedAppInstallPostbackPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.AdvancedAppInstallPostbackPage };
  }),
);
const CampaignsSettingsPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.CampaignsSettingsPage };
  }),
);
const PaymentsPage = lazy(() =>
  import('views').then((module) => {
    return { default: module.PaymentsPage };
  }),
);

const Routes = {
  list: [
    {
      id: 'manageApps/appSettings/placements',
      url: '/manage_apps/app_settings/placements/:pba_id',
      caseSensitive: true,
      element: <LocalPlacementsPage />,
      //availableForRoles: ['admin', 'publisher'],
    },
    {
      id: 'manageApps/appSettings/appInstallPostback',
      url: '/manage_apps/app_settings/app_install_postback/:pba_id',
      caseSensitive: true,
      element: <LocalAppInstallPostbackPage />,
      //availableForRoles: ['admin', 'publisher'],
    },
    {
      id: 'manageApps/appSettings/minimumServing',
      url: '/manage_apps/app_settings/minimum_serving/:pba_id',
      caseSensitive: true,
      element: <LocalMinimumServingPage />,
      //availableForRoles: ['admin', 'publisher'],
    },
    {
      id: 'manageApps/appSettings/excludeSettings',
      url: '/manage_apps/advanced_settings/exclude_settings/:pba_id',
      caseSensitive: true,
      element: <LocalExcludeSettingsPage />,
      //availableForRoles: ['admin', 'publisher', 'advertiser'],
    },
    {
      id: 'manageApps',
      url: `/manage_apps/`,
      caseSensitive: false,
      element: <ManageApps />,
      redirectToSamsung: '/reports',
      //availableForRoles: ['admin', 'publisher', 'advertiser'],
    },
    {
      id: 'manageApps',
      url: '/manage_apps/new',
      caseSensitive: false,
      element: <ManageApps />,
      redirectToSamsung: '/reports',
      //availableForRoles: ['admin', 'publisher', 'advertiser'],
    },
    {
      id: 'manageApps/appInstallPostback',
      url: '/manage_apps/advanced_settings/app_install_postback/',
      caseSensitive: true,
      element: <AdvancedAppInstallPostbackPage />,
      redirectToSamsung: '/reports',
      //availableForRoles: ['admin', 'publisher'],
    },
    {
      id: 'manageApps/minimumServing',
      url: '/manage_apps/advanced_settings/minimum_serving/',
      caseSensitive: true,
      element: <AdvancedMinimumServingPage />,
      redirectToSamsung: '/reports',
      //availableForRoles: ['admin', 'publisher'],
    },
    {
      id: 'manageApps/excludeSettings',
      url: '/manage_apps/advanced_settings/exclude_settings',
      caseSensitive: true,
      element: <AdvancedExcludeSettingsPage />,
      redirectToSamsung: '/reports',
      //availableForRoles: ['admin', 'publisher', 'advertiser'],
    },
    {
      id: 'manageApps/appSettings/generalSettings',
      url: '/manage_apps/app_settings/general_settings/:pba_id',
      caseSensitive: true,
      element: <GeneralSettingsPage />,
      redirectToSamsung: '/reports',
    },
    {
      id: 'dashboard',
      url: '/dash1',
      caseSensitive: false,
      element: <Dashboard />,
    },
    {
      id: 'accountSettings',
      url: '/account-settings',
      caseSensitive: false,
      element: <AccountSettingsPage />,
    },
    {
      id: 'campaign',
      url: '/Discovery/Manage',
      caseSensitive: false,
      element: <CampaignsManager />,
      availableForRoles: ['advertiser'],
      redirectTo: '/manage_apps/',
    },
    {
      id: 'campaign_v2',
      url: 'Discovery/Manage_v2',
      caseSensitive: false,
      element: <CampaignsManager_v2 />,
      availableForRoles: ['advertiser'],
      redirectTo: '/manage_apps/',
    },
    {
      id: 'campaign/editCampaign',
      url: '/Discovery/Campaign/Edit/:cmp_id',
      caseSensitive: false,
      element: <EditCampaignPage />,
      availableForRoles: ['advertiser'],
      redirectTo: '/manage_apps/',
    },
    {
      id: 'campaign/newCampaign_empty',
      url: '/Discovery/Campaign/New',
      caseSensitive: false,
      element: <NewCampaign_emptyPage />,
      availableForRoles: ['advertiser'],
      redirectTo: '/manage_apps/',
    },
    {
      id: 'campaign/duplicateCampaign',
      url: '/Discovery/Campaign/Duplicate/:cmp_id',
      caseSensitive: false,
      element: <DuplicateCampaignPage />,
      availableForRoles: ['advertiser'],
      redirectTo: '/manage_apps/',
    },
    {
      id: 'campaign/directCampaign',
      url: '/Discovery/Campaign/Direct/:cmp_id',
      caseSensitive: false,
      element: <DirectCampaignPage />,
    },
    {
      id: 'reports',
      url: '/reports',
      caseSensitive: true,
      element: <PublisherReports />,
    },
    {
      id: 'campaignReports',
      url: '/Discovery/CampaignReports/:cmp_id',
      caseSensitive: false,
      element: <CampaignReports />,
    },
    {
      id: 'campaign/campaignsSettings',
      url: `/Discovery/Campaign/Settings/*`,
      caseSensitive: false,
      element: <CampaignsSettingsPage />,
    },
    {
      id: 'payments',
      url: '/payments',
      caseSensitive: false,
      element: <PaymentsPage />,
    },
  ],
  notFound: {
    component: (
      <main style={{ padding: '1rem' }}>
        <p>There&apos;s nothing here!</p>
      </main>
    ),
  },
};

export default Routes;
